import { Section } from "./sections";
import { stableKey } from "./format";

function ConstraintsBlock({ data }) {
  const entries = Object.entries(data || {}).filter(
    ([, v]) =>
      v !== null && v !== undefined && v !== "" &&
      !(Array.isArray(v) && v.length === 0),
  );
  if (entries.length === 0) {
    return <div className="text-sm text-slate-400">None recorded</div>;
  }
  return (
    <ul className="text-sm text-slate-700 space-y-0.5">
      {entries.map(([k, v]) => (
        <li key={k}>
          <span className="text-slate-500">{k}:</span>{" "}
          {Array.isArray(v) ? v.join(", ") : String(v)}
        </li>
      ))}
    </ul>
  );
}

export default function InterestsAndConstraints({ hobbies, constraints }) {
  return (
    <Section title="Interests & constraints" testid="sect-extra" full>
      <div className="md:col-span-2">
        <div className="text-xs uppercase tracking-wide text-slate-500 mb-1">
          Interests / hobbies
        </div>
        {hobbies.length > 0 ? (
          <ul className="list-disc pl-5 text-sm text-slate-700 space-y-0.5">
            {hobbies.map((h, idx) => (
              <li key={stableKey(h, `hobby-${idx}`)}>
                {typeof h === "string" ? h : h.name || JSON.stringify(h)}
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-sm text-slate-400">—</div>
        )}
      </div>
      <div className="md:col-span-2">
        <div className="text-xs uppercase tracking-wide text-slate-500 mb-1">
          Physical constraints
        </div>
        <ConstraintsBlock data={constraints} />
      </div>
    </Section>
  );
}
